/* Select SVG component based on ACF field */

export default {
  methods: {
    IconSVG(item) {
      return `${item}SVG`;
    },
  },
};
